import { Injectable } from '@angular/core';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ArrivePlanService {
  private apiUrl = '/arriveplans';
  private apiSpringUrl = '/spring/arriveplans';

  constructor(private http: HttpService) { }

  get(ownerId: number, showAll: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?ownerId=${ownerId}&showAll=${showAll}`;
    return this.http.get(url);
  }

  post(data: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl;
    return this.http.post(url, data);
  }

  delete(arrivePlanId: number[]): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/delete`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < arrivePlanId.length; i++) {
      jsonUnit.push({
        arriveplanId: arrivePlanId[i]
      });
    }
    const jsonInput: object = { selectItems: jsonUnit };
    return this.http.post(url, jsonInput);
  }

  upload(file: File, ownerId?: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/excelupload/${ownerId}`;
    const formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    const header = {
      'Accept': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    };
    return this.http.post(url, formData, header);
  }

  forced(arrivePlanId: number[]): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/forced`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < arrivePlanId.length; i++) {
      jsonUnit.push({
        arriveplanId: arrivePlanId[i]
      });
    }
    const jsonInput: object = { selectItems: jsonUnit };
    return this.http.post(url, jsonInput);
  }

  complete(
    ownerId: number,
    details: any,
    updprogramCd: string
  ) {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/complete`;
    const jsonInput = {
      ownerId: ownerId,
      details: details,
      updprogramCd: updprogramCd
    };
    console.log("jsonInput=="); console.log(jsonInput);
    return this.http.post(url, jsonInput);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/arrive-plan/arrive-plan.service.ts